import BarcodeVerifyFailedModal from './BarcodeVerifyFailedModal';

const generalManagementModals = {
	BarcodeVerifyFailedModal,
}

export default generalManagementModals;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/generalManagement/index.jsx